import { FlexBox } from "components/Common/FlexBox"
import { Link } from "react-router-dom"
import styled from "styled-components"

export const DailyTargetWrapper = styled.div`
  display: flex;
  padding: var(--spacing_l, 16px);
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 16px;

  border-radius: var(--spacing_m, 12px);
  border: 1px solid var(--Primitive-White_5, rgba(255, 255, 255, 0.05));
  background: var(--Primitive-White_5, rgba(255, 255, 255, 0.05));
`

export const YourDailyTargetHeader = styled(FlexBox)`
  width: 100%;
  justify: space-between;
`

export const DailyTargetTitle = styled.div`
  color: var(--Schemes-Surface-Surface-Container-Lowest, #fff);
  font-feature-settings: "liga" off, "clig" off;

  font-size: 16px;
  font-weight: 800;
  line-height: 140%; /* 22.4px */
`

export const CustomizeBtn = styled(Link)`
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px; /* 100% */
  letter-spacing: 0.16px;
  cursor: pointer;
  color: var(--Schemes-Primary-container-Primary-Container, #4bd9de);
  line-height: 16px;
  text-decoration: none;
`

export const DailyText = styled.div`
  color: var(--Primitive-White_60, rgba(255, 255, 255, 0.6));
  font-size: 14px;
  line-height: 160%;

  p {
    margin: 0 0 6px 0;

    &:last-child {
      margin-bottom: 0;
    }
  }
`
